export default function CsharpImplicitCasting() {
  return (
    <h2>Csharp Implicit Casting</h2>
  );
}
